import BaseComponent from '../../../js/base-component';
import { Modal } from '../../../js/modal';

class CareProductsStepNine extends BaseComponent {
    constructor(element) {
        super(element);

        this.editButton = this.element.querySelectorAll('.u-edit--person');
        this.editModalContainer = document.querySelector('#editModal') || '';
        this.editModal = new Modal( this.editModalContainer );

        this.editButton.forEach( element => {
            element.addEventListener('click', (evt) => {
                this.editModal.handleModal('person','open', {id: element.dataset.id, contract: element.dataset.contract, headline: element.dataset.headline });
            });
        });
    }
}

export default {
    name: 'CareProductsStepNine',
    definition: CareProductsStepNine
};